import {
  useTheme
} from "./chunk-JVDTBYWX.js";
import {
  switchTheme
} from "./chunk-7SWBG6UK.js";

// src/components/switch.tsx
import * as React from "react";
import { twMerge } from "tailwind-merge";
import { jsx } from "react/jsx-runtime";
function SwitchRoot({ color, className, ...props }, ref) {
  const innerID = React.useId();
  const contextTheme = useTheme();
  const theme = contextTheme?.switch ?? switchTheme;
  const defaultProps = theme?.defaultProps;
  color ??= defaultProps?.color ?? "primary";
  const styles = twMerge(
    theme.baseStyle,
    theme.trackStyle,
    theme.circleStyle,
    theme.color[color],
    className
  );
  return /* @__PURE__ */ jsx(
    "input",
    {
      ...props,
      ref,
      type: "checkbox",
      className: styles,
      id: props?.id || innerID
    }
  );
}
SwitchRoot.displayName = "MaterialTailwind.Switch";
var Switch = React.forwardRef(SwitchRoot);
var switch_default = Switch;

export {
  Switch,
  switch_default
};
